import React, { useState } from "react";
import {
  Box,
  Paper,
  Grid,
  TextField,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormLabel,
  Container,
  Modal,
  Card,
  CardContent,
  IconButton,
  Divider,
  Tooltip,
  MenuItem,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useDispatch } from "react-redux";
import { message } from "antd";
import { QRCodeCanvas } from "qrcode.react";
import Navbar from "../../Components/Navbar";
import Header from "../../Components/Header";
import Footer from "../../Components/Footer";
import PageTitle from "../../Components/PageTitle";
import CustomButton from "../../Components/CustomButton";
import { createAdmission } from "../../redux/actions/admissionActions";
import School from "../../assets/ShreeSchool.jpeg";

export default function AdmissionForm() {
  const theme = useTheme();
  const dispatch = useDispatch();

  const [form, setForm] = useState({
    studentName: "",
    fatherName: "",
    motherName: "",
    birthDate: "",
    gender: "Male",
    presentDivision: "",
    presentDistrict: "",
    presentAddress: "",
    permanentDivision: "",
    permanentDistrict: "",
    permanentAddress: "",
    phone: "",
    email: "",
    courseName: "",
    className: "",
  });

  const [transactionId, setTransactionId] = useState("");
  const [paymentSubmitting, setPaymentSubmitting] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [copied, setCopied] = useState(false);

  const totalFees = 0; // Fixed amount
  const upiId = "msola33052@ybl"; // Same UPI ID

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(upiId);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  const validateForm = () => {
    const requiredFields = [
      "studentName",
      "fatherName",
      "motherName",
      "birthDate",
      "phone",
      "email",
    ];

    const errors = [];

    // Basic required fields
    requiredFields.forEach((field) => {
      if (!form[field]?.trim()) {
        const fieldNames = {
          studentName: "Student Name",
          fatherName: "Father's Name",
          motherName: "Mother's Name",
          birthDate: "Date of Birth",
          phone: "Phone Number",
          email: "Email Address",
        };
        errors.push(`${fieldNames[field]} is required`);
      }
    });

    // Either Class OR Course must be selected (but not both?)
    if (!form.className?.trim() && !form.courseName?.trim()) {
      errors.push("Please select either Class Name or Course Name");
    }

    // Phone validation
    if (form.phone && !/^\d{10}$/.test(form.phone)) {
      errors.push("Phone number must be 10 digits");
    }

    // Email validation
    if (form.email && !/^\S+@\S+\.\S+$/.test(form.email)) {
      errors.push("Please enter a valid email address");
    }

    return errors;
  };
  // const handleFormSubmit = (e) => {
  //   e.preventDefault();
  //   setLoading(true);

  //   const validationErrors = validateForm();

  //   if (validationErrors.length > 0) {
  //     validationErrors.forEach((error) => message.error(error));
  //     setLoading(false);
  //     return;
  //   }

  //   // Show payment modal
  //   setOpenModal(true);
  //   setLoading(false);
  // };

  // const handleFormSubmit = (e) => {
  //   e.preventDefault();
  //   setLoading(true);

  //   const validationErrors = validateForm();

  //   if (validationErrors.length > 0) {
  //     validationErrors.forEach((error) => message.error(error));
  //     setLoading(false);
  //     return;
  //   }

  //   const admissionData = {
  //     ...form,
  //     paymentStatus: "Pending", // ya "Not Required" agar payment hi nahi chahiye
  //     paymentDate: new Date().toISOString().split("T")[0],
  //   };

  //   dispatch(createAdmission(admissionData))
    
  //     .then(() => {
  //       message.success("Admission submitted successfully");

  //       setForm({
  //         studentName: "",
  //         fatherName: "",
  //         motherName: "",
  //         birthDate: "",
  //         gender: "Male",
  //         presentDivision: "",
  //         presentDistrict: "",
  //         presentAddress: "",
  //         permanentDivision: "",
  //         permanentDistrict: "",
  //         permanentAddress: "",
  //         phone: "",
  //         email: "",
  //         courseName: "",
  //         className: "",
  //       });
  //     })

  //     .catch(() => {
  //       message.error("Failed to submit admission. Please try again.");
  //     })
  //     .finally(() => {
  //       setLoading(false);
  //     });
  // };

  const handleFormSubmit = (e) => {
  e.preventDefault();
  setLoading(true);

  const validationErrors = validateForm();

  if (validationErrors.length > 0) {
    validationErrors.forEach((error) => message.error(error));
    setLoading(false);
    return;
  }

  const admissionData = {
    ...form,
    paymentStatus: "Pending",
    paymentDate: new Date().toISOString().split("T")[0],
  };

 dispatch(createAdmission(admissionData))
  .then((res) => {
    // ✅ Submit success maana jaayega
    message.success("Admission submitted successfully");

    // 🔥 GTM Event
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "form_submission_success",
    });

    // ✅ FORM RESET (guaranteed)
    setForm({
      studentName: "",
      fatherName: "",
      motherName: "",
      birthDate: "",
      gender: "Male",
      presentDivision: "",
      presentDistrict: "",
      presentAddress: "",
      permanentDivision: "",
      permanentDistrict: "",
      permanentAddress: "",
      phone: "",
      email: "",
      courseName: "",
      className: "",
    });
  })
  .catch((err) => {
    console.error("Admission error:", err);
    message.error("Failed to submit admission. Please try again.");
  })
  .finally(() => {
    setLoading(false);
  });

};


  const handlePaymentConfirm = () => {
    if (!transactionId.trim()) {
      message.error("Please enter Transaction ID");
      return;
    }

    setPaymentSubmitting(true);

    // Prepare admission data with transaction ID
    const admissionData = {
      ...form,
      transactionId: transactionId.trim(),
      totalFees: totalFees.toString(),
      paymentStatus: "Pending",
      paymentDate: new Date().toISOString().split("T")[0],
    };
    // Dispatch action to save admission
    dispatch(createAdmission(admissionData))
      .then(() => {
        message.success("Admission submitted successfully");
        // Reset form
        setForm({
          studentName: "",
          fatherName: "",
          motherName: "",
          birthDate: "",
          gender: "Male",
          presentDivision: "",
          presentDistrict: "",
          presentAddress: "",
          permanentDivision: "",
          permanentDistrict: "",
          permanentAddress: "",
          phone: "",
          email: "",
          courseName: "",
          className: "",
        });
        setTransactionId("");
        setOpenModal(false);
      })
      .catch((error) => {
        message.error("Failed to submit admission. Please try again.");
      })
      .finally(() => {
        setPaymentSubmitting(false);
      });
  };

  return (
    <>
      <Navbar />
      <PageTitle
        title="Admission Form - Shree Mangalam School"
        description="Pay your school or coaching fees securely online at Shree Mangalam School. Simple, safe, and fast fee payment for all programs including RIMC and Sainik School coaching."
        url="/online-fees"
        keywords="online fees payment, pay school fees, Shree Manglam fees, RIMC coaching fees, sainik school fee payment, secure fee portal"
      />
      <Header image={School} alt={"Shree Mangalam School"} />

      <Container sx={{ my: 5 }}>
        <Typography
          variant="h5"
          sx={{
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            fontSize: "30px",
            letterSpacing: 1,
            color: "#065A79",
            fontWeight: "bold",
          }}
          gutterBottom
        >
          Admission Form
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          Please fill the admission form below. After submitting the form, you
          will be redirected to the payment page where you can pay the admission
          fees.
        </Typography>

        <Paper
          elevation={3}
          sx={{
            p: 4,
            mt: 4,
            borderRadius: 3,
            mx: "auto",
            bgcolor: "background.paper",
          }}
        >
          <form onSubmit={handleFormSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={12}>
                <TextField
                  fullWidth
                  label="Student's Name"
                  name="studentName"
                  value={form.studentName}
                  onChange={handleChange}
                  InputLabelProps={{
                    sx: {
                      color: "#065A79",
                      "&.Mui-focused": {
                        color: "#AD1C86",
                        fontWeight: "bold",
                      },
                    },
                  }}
                  sx={{
                    "& input[type='number']": {
                      MozAppearance: "textfield",
                      "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button":
                        {
                          display: "none",
                        },
                    },
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "#065A79",
                      },
                      "&:hover fieldset": {
                        borderColor: "#065A79",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#AD1C86",
                      },
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderRadius: "10px",
                      },
                    },
                  }}
                />
              </Grid>

              <Grid item xs={12} md={12}>
                <TextField
                  fullWidth
                  label="Father's Name"
                  name="fatherName"
                  value={form.fatherName}
                  onChange={handleChange}
                  InputLabelProps={{
                    sx: {
                      color: "#065A79",
                      "&.Mui-focused": {
                        color: "#AD1C86",
                        fontWeight: "bold",
                      },
                    },
                  }}
                  sx={{
                    "& input[type='number']": {
                      MozAppearance: "textfield",
                      "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button":
                        {
                          display: "none",
                        },
                    },
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "#065A79",
                      },
                      "&:hover fieldset": {
                        borderColor: "#065A79",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#AD1C86",
                      },
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderRadius: "10px",
                      },
                    },
                  }}
                />
              </Grid>

              <Grid item xs={12} md={12}>
                <TextField
                  fullWidth
                  label="Mother's Name"
                  name="motherName"
                  value={form.motherName}
                  onChange={handleChange}
                  InputLabelProps={{
                    sx: {
                      color: "#065A79",
                      "&.Mui-focused": {
                        color: "#AD1C86",
                        fontWeight: "bold",
                      },
                    },
                  }}
                  sx={{
                    "& input[type='number']": {
                      MozAppearance: "textfield",
                      "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button":
                        {
                          display: "none",
                        },
                    },
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "#065A79",
                      },
                      "&:hover fieldset": {
                        borderColor: "#065A79",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#AD1C86",
                      },
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderRadius: "10px",
                      },
                    },
                  }}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Birth Date"
                  name="birthDate"
                  type="date"
                  value={form.birthDate}
                  onChange={handleChange}
                  InputLabelProps={{
                    shrink: true,
                    sx: {
                      color: "#065A79",
                      "&.Mui-focused": {
                        color: "#AD1C86",
                        fontWeight: "bold",
                      },
                    },
                  }}
                  sx={{
                    mt: 1,
                    "& input[type='number']": {
                      MozAppearance: "textfield",
                      "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button":
                        {
                          display: "none",
                        },
                    },
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "#065A79",
                      },
                      "&:hover fieldset": {
                        borderColor: "#065A79",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#AD1C86",
                      },
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderRadius: "10px",
                      },
                    },
                  }}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <Box display="flex" alignItems="center" sx={{ mt: 2 }}>
                  <FormLabel sx={{ mr: 2 }}>Gender:</FormLabel>

                  <RadioGroup
                    row
                    name="gender"
                    value={form.gender}
                    onChange={handleChange}
                    sx={{ display: "flex", flexDirection: "row" }}
                  >
                    <FormControlLabel
                      value="Male"
                      control={<Radio />}
                      label="Male"
                    />
                    <FormControlLabel
                      value="Female"
                      control={<Radio />}
                      label="Female"
                    />
                  </RadioGroup>
                </Box>
              </Grid>

              {/* Present Address */}
              <Grid item xs={12}>
                <Typography
                  sx={{
                    fontWeight: 600,
                    color: "#AD1C86",
                    letterSpacing: 1,
                  }}
                  variant="subtitle1"
                >
                  Present Address
                </Typography>
              </Grid>

              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Division"
                  name="presentDivision"
                  value={form.presentDivision}
                  onChange={handleChange}
                  InputLabelProps={{
                    sx: {
                      color: "#065A79",
                      "&.Mui-focused": {
                        color: "#AD1C86",
                        fontWeight: "bold",
                      },
                    },
                  }}
                  sx={{
                    "& input[type='number']": {
                      MozAppearance: "textfield",
                      "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button":
                        {
                          display: "none",
                        },
                    },
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "#065A79",
                      },
                      "&:hover fieldset": {
                        borderColor: "#065A79",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#AD1C86",
                      },
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderRadius: "10px",
                      },
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="District"
                  name="presentDistrict"
                  value={form.presentDistrict}
                  onChange={handleChange}
                  InputLabelProps={{
                    sx: {
                      color: "#065A79",
                      "&.Mui-focused": {
                        color: "#AD1C86",
                        fontWeight: "bold",
                      },
                    },
                  }}
                  sx={{
                    "& input[type='number']": {
                      MozAppearance: "textfield",
                      "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button":
                        {
                          display: "none",
                        },
                    },
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "#065A79",
                      },
                      "&:hover fieldset": {
                        borderColor: "#065A79",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#AD1C86",
                      },
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderRadius: "10px",
                      },
                    },
                  }}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  fullWidth
                  multiline
                  minRows={2}
                  label="Address"
                  name="presentAddress"
                  value={form.presentAddress}
                  onChange={handleChange}
                  InputLabelProps={{
                    sx: {
                      color: "#065A79",
                      "&.Mui-focused": {
                        color: "#AD1C86",
                        fontWeight: "bold",
                      },
                    },
                  }}
                  sx={{
                    "& input[type='number']": {
                      MozAppearance: "textfield",
                      "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button":
                        {
                          display: "none",
                        },
                    },
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "#065A79",
                      },
                      "&:hover fieldset": {
                        borderColor: "#065A79",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#AD1C86",
                      },
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderRadius: "10px",
                      },
                    },
                  }}
                />
              </Grid>

              {/* Permanent Address */}
              <Grid item xs={12}>
                <Typography
                  sx={{
                    fontWeight: 600,
                    color: "#AD1C86",
                    letterSpacing: 1,
                  }}
                  variant="subtitle1"
                >
                  Permanent Address
                </Typography>
              </Grid>

              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Division"
                  name="permanentDivision"
                  value={form.permanentDivision}
                  onChange={handleChange}
                  InputLabelProps={{
                    sx: {
                      color: "#065A79",
                      "&.Mui-focused": {
                        color: "#AD1C86",
                        fontWeight: "bold",
                      },
                    },
                  }}
                  sx={{
                    "& input[type='number']": {
                      MozAppearance: "textfield",
                      "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button":
                        {
                          display: "none",
                        },
                    },
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "#065A79",
                      },
                      "&:hover fieldset": {
                        borderColor: "#065A79",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#AD1C86",
                      },
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderRadius: "10px",
                      },
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="District"
                  name="permanentDistrict"
                  value={form.permanentDistrict}
                  onChange={handleChange}
                  InputLabelProps={{
                    sx: {
                      color: "#065A79",
                      "&.Mui-focused": {
                        color: "#AD1C86",
                        fontWeight: "bold",
                      },
                    },
                  }}
                  sx={{
                    "& input[type='number']": {
                      MozAppearance: "textfield",
                      "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button":
                        {
                          display: "none",
                        },
                    },
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "#065A79",
                      },
                      "&:hover fieldset": {
                        borderColor: "#065A79",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#AD1C86",
                      },
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderRadius: "10px",
                      },
                    },
                  }}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  fullWidth
                  multiline
                  minRows={2}
                  label="Address"
                  name="permanentAddress"
                  value={form.permanentAddress}
                  onChange={handleChange}
                  InputLabelProps={{
                    sx: {
                      color: "#065A79",
                      "&.Mui-focused": {
                        color: "#AD1C86",
                        fontWeight: "bold",
                      },
                    },
                  }}
                  sx={{
                    "& input[type='number']": {
                      MozAppearance: "textfield",
                      "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button":
                        {
                          display: "none",
                        },
                    },
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "#065A79",
                      },
                      "&:hover fieldset": {
                        borderColor: "#065A79",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#AD1C86",
                      },
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderRadius: "10px",
                      },
                    },
                  }}
                />
              </Grid>

              {/* Other info */}
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Phone Number"
                  name="phone"
                  value={form.phone}
                  onChange={handleChange}
                  InputLabelProps={{
                    sx: {
                      color: "#065A79",
                      "&.Mui-focused": {
                        color: "#AD1C86",
                        fontWeight: "bold",
                      },
                    },
                  }}
                  sx={{
                    "& input[type='number']": {
                      MozAppearance: "textfield",
                      "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button":
                        {
                          display: "none",
                        },
                    },
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "#065A79",
                      },
                      "&:hover fieldset": {
                        borderColor: "#065A79",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#AD1C86",
                      },
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderRadius: "10px",
                      },
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Email Address"
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                  InputLabelProps={{
                    sx: {
                      color: "#065A79",
                      "&.Mui-focused": {
                        color: "#AD1C86",
                        fontWeight: "bold",
                      },
                    },
                  }}
                  sx={{
                    "& input[type='number']": {
                      MozAppearance: "textfield",
                      "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button":
                        {
                          display: "none",
                        },
                    },
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "#065A79",
                      },
                      "&:hover fieldset": {
                        borderColor: "#065A79",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#AD1C86",
                      },
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderRadius: "10px",
                      },
                    },
                  }}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Class Name"
                  name="className"
                  value={form.className}
                  onChange={handleChange}
                  InputLabelProps={{
                    sx: {
                      color: "#065A79",
                      "&.Mui-focused": {
                        color: "#AD1C86",
                        fontWeight: "bold",
                      },
                    },
                  }}
                  sx={{
                    "& input[type='number']": {
                      MozAppearance: "textfield",
                      "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button":
                        {
                          display: "none",
                        },
                    },
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "#065A79",
                      },
                      "&:hover fieldset": {
                        borderColor: "#065A79",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#AD1C86",
                      },
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderRadius: "10px",
                      },
                    },
                  }}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <TextField
                  select
                  fullWidth
                  label="Select Course *"
                  name="courseName"
                  value={form.courseName}
                  onChange={handleChange}
                  SelectProps={{
                    MenuProps: {
                      PaperProps: {
                        sx: {
                          maxHeight: 300,
                        },
                      },
                    },
                  }}
                  InputLabelProps={{
                    sx: {
                      color: "#065A79",
                      "&.Mui-focused": {
                        color: "#AD1C86",
                        fontWeight: "bold",
                      },
                    },
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "#065A79",
                      },
                      "&:hover fieldset": {
                        borderColor: "#065A79",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#AD1C86",
                      },
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderRadius: "10px",
                      },
                    },
                  }}
                >
                  <MenuItem value="">Select a course</MenuItem>
                  <MenuItem value="Navodaya">
                    Navodaya Vidyalaya Preparation
                  </MenuItem>
                  <MenuItem value="RIMC">
                    RIMC (Rashtriya Indian Military College)
                  </MenuItem>
                  <MenuItem value="Sainik">Sainik School</MenuItem>
                  <MenuItem value="Military">Military School</MenuItem>
                  <MenuItem value="Other">Other</MenuItem>
                </TextField>
              </Grid>

              <Grid item xs={12} sx={{ textAlign: "right" }}>
                <Box sx={{ display: "flex", justifyContent: "center" }}>
                  {/* <CustomButton
                    ButtonName={
                      loading ? "Validating..." : "Proceed to Payment"
                    }
                    type="submit"
                    disabled={loading}
                    handleSubmit={handleFormSubmit}
                  /> */}

                  <CustomButton
                    ButtonName={loading ? "Submitting..." : "Submit Admission"}
                    type="submit"
                    disabled={loading}
                    handleSubmit={handleFormSubmit}
                  />
                </Box>
              </Grid>
            </Grid>
          </form>
        </Paper>
      </Container>

      {/* Payment Modal */}
      <Modal
        open={openModal}
        onClose={() => setOpenModal(false)}
        sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
      >
        <Card sx={{ maxWidth: 450, width: "100%", borderRadius: 3, p: 3 }}>
          <Box sx={{ textAlign: "center", mb: 2 }}>
            <Typography variant="h5" sx={{ fontWeight: "bold" }}>
              Payment Required
            </Typography>
            <Typography variant="subtitle1">
              Please complete the payment to submit your admission
            </Typography>
          </Box>

          <CardContent
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Typography variant="h6" sx={{ mb: 2 }}>
              Total Amount: ₹{totalFees}
            </Typography>

            <Typography variant="body2" sx={{ mb: 2, textAlign: "center" }}>
              Scan QR code using any UPI app or copy UPI ID below
            </Typography>

            <Box
              sx={{
                p: 2,
                border: `2px dashed ${theme.palette.divider}`,
                borderRadius: 2,
                mb: 2,
              }}
            >
              <QRCodeCanvas
                value={`upi://pay?pa=${upiId}&pn=ShreeMangalamSchool&am=${totalFees}&cu=INR&tn=Admission%20Fees%20for%20${encodeURIComponent(
                  form.studentName,
                )}`}
                size={220}
                level="H"
                includeMargin={true}
              />
            </Box>

            <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
              <Typography variant="body2">
                UPI ID: <strong>{upiId}</strong>
              </Typography>
              <Tooltip title={copied ? "Copied!" : "Copy UPI ID"}>
                <IconButton size="small" onClick={handleCopy}>
                  <ContentCopyIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            </Box>

            <Typography
              variant="caption"
              sx={{ color: "text.secondary", mb: 2, textAlign: "center" }}
            >
              After payment, please enter the transaction ID below
            </Typography>

            <TextField
              label="Transaction ID *"
              value={transactionId}
              onChange={(e) => setTransactionId(e.target.value)}
              fullWidth
              sx={{ mt: 2 }}
              required
              placeholder="Enter UPI transaction ID"
            />

            <Divider sx={{ width: "100%", my: 2 }} />

            <Box sx={{ display: "flex", gap: 2, width: "100%" }}>
              <CustomButton
                ButtonName="Cancel"
                variant="outlined"
                fullWidth
                handleSubmit={() => setOpenModal(false)}
              />
              <CustomButton
                ButtonName={
                  paymentSubmitting ? "Submitting..." : "Confirm Payment"
                }
                disabled={!transactionId.trim() || paymentSubmitting}
                fullWidth
                handleSubmit={handlePaymentConfirm}
              />
            </Box>
          </CardContent>
        </Card>
      </Modal>

      <Footer />
    </>
  );
}
